module.exports = __webpack_public_path__ + "static/img/ag_6.5a8e50f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/ag_6.png
// module id = 865
// module chunks = 1